/* global $ */
import { TweenMax } from 'gsap';

import { createElement, Component } from 'rlink-react';
import NavLink from 'rlink-router/NavLink';
import { HASH } from 'rlink-router/constants';
import themeable from 'rlink-theme/themeable';

import getArticleLoader from 'helpers/getArticleLoader';

export default class CandidateNotice extends Component {
  componentWillUpdate (_nextProps, _nextState) {
    TweenMax.delayedCall(1, () => {
      $('.ajax-node').show();
      this.loaderObj.hide();
    });
  }

  showLoaderCallback () {
    $('.ajax-node').hide();
    TweenMax.delayedCall(0.5, () => {
      let $existingNode = $('.ajax-node');
      if ($existingNode.length) {
        TweenMax.delayedCall(1, () => {
          $existingNode.show();
          this.loaderObj.hide();
        });
      }
    });
  }

  componentDidMount () {
    if (typeof document !== 'undefined') {
      $('html').addClass('candidate-notice');
      this.loaderObj = getArticleLoader();

      // show() returns false if already showing and undefined if not showing
      // In the case where it returns false the callback is not run.
      let didShowTrigger = this.loaderObj.show(() => {
        this.showLoaderCallback();
      });
      if (didShowTrigger === false) {
        this.showLoaderCallback();
      }

    }
  }

  onClose () {
    this.loaderObj.show(() => {
      TweenMax.delayedCall(1.0, () => {
        $('.ajax-node').hide();
        this.loaderObj.hide();
        $('html').removeClass('candidate-notice');
        $(window).trigger('scroll-careers');
      });
    });
  }

  render () {
    let {theme} = this.props;
    return (
      <div className={theme.Container}>
        <div className={theme.ArticleWrapper}>
          <article className={theme.Article}>
            <div className="body field">
              <h2>Application for Employment (the “Notice”)</h2>
              <p>Relic Entertainment Inc. (“
                <strong>Relic</strong>”), an affiliate company of SEGA Europe Limited (together,
                “<strong>SEGA Group Company</strong>”) is committed to protecting and respecting your privacy. We will treat your personal
                data confidentially and will comply with European data protection legislation in respect of our processing activities.</p>
              <p>By&nbsp;clicking the "I Accept" button you agree to the processing by the SEGA Group Companies and Greenhouse Software,
                Inc. of your personal data and you acknowledge that you have read and understood the following:</p>
              <h3>Information we collect from you</h3>
              <p>The types of personal data, that we may collect from you include, but are not limited to, first and last name, contact
                information, and career history data. We may also refer to information set out on your LinkedIn profile when considering
                your application.</p>
              <h3>Pre-employment screening checks</h3>
              <p>We do not perform criminal background checks or other such screening as part of the application process, although,
                following an offer of employment, your role may be subject to pre-employment screening, if permitted by applicable
                law.&nbsp; The type of screening (if any) will depend on the role for which you've applied.</p>
              <h3>How we use your information</h3>
              <p>As part of your application for employment at Relic, the data you provide in your application, including that from
                any interviews, pre-selection processes with which you engage and references that you provide (with the referees’
                consent), will be held on our computers or manually in our files. The data will be used by Relic to process your
                application and ultimately where your application is successful, so that Relic can make an offer of employment. &nbsp;</p>
              <p>We will send you the results of your application at the e-mail address that you have provided to Relic.&nbsp; If your
                application is successful, the data which you provide will be used to administer your personnel record at Relic and
                will be subject to our staff privacy policy.&nbsp;We take security very seriously, which is why we use technical
                and organisational security measures to help safeguard your personal data.</p>
              <h3>Sharing your information</h3>
              <p>Relic uses a third-party solution (Greenhouse Software, Inc.) to administer our recruitment processes online. You can
                find information about how Greenhouse Software, Inc. processes your personal information&nbsp;
                <a rel="noopener" className={theme.BodyLink} target="_blank" href="https://www.greenhouse.io/privacy-policy">here</a>.</p>
              <p>Relic does not disclose your personal data to unauthorised third parties. However, as Relic is part of a global corporation
                consisting of several offices in various countries, we will use resources located throughout the world. To the extent
                necessary as part of the recruitment process, your personal data may be transferred and/or disclosed to any SEGA
                Group Company as well as to third parties acting on our behalf. This may also include&nbsp;transfers to servers and
                databases outside the country where you provided us with your personal data. Such transfers may include for example
                transfers to countries within the European Economic Area whose data protection practices are subject to tests of
                adequacy to ensure the security of your data. Where we transfer personal data, we will seek to take account of any
                applicable statutory obligations relevant to personal data transfers, including Privacy Shield certification or EC
                approved standard contractual clauses. We will also ensure compliance with Canadian data protection legislation when
                processing and/or transferring your personal data.</p>
              <h3>Retention of recruitment records</h3>
              <p>If your application is successful, we will move your recruitment information to your employment files. We will only
                move information that is relevant to your on-going employment. Once you are employed at a SEGA Group Company, how
                we handle your personal data is governed by the staff privacy policy and, if applicable, your employment contract.</p>
              <p>If your application is unsuccessful, application forms and related documentation will be kept on file for twenty-four
                (24) months from your application date, so that Relic may contact you in respect of future vacancies that may be
                of interest to you. Relic will also retain your personal data as needed to comply with any legal or document retention
                obligations.</p>
              <p>If you do not wish for the SEGA Group Companies and/or Greenhouse Software, Inc. to continue to process your personal
                data in the ways described in this Notice, you can request in writing that you do not want us to do so by contacting
                us at is&nbsp;
                <a rel="noopener" className={theme.BodyLink} target="_blank" href="mailto:jobs@sega.co.uk">jobs@sega.co.uk</a>.</p>
              <p>After they are no longer needed, we will dispose of your records in a secure manner and in accordance with our records
                management policies.</p>
              <h3>Your rights</h3>
              <p>You have a right to request a copy of the personal data that we hold about you at any time and can have that information
                corrected if it is inaccurate. If you wish to exercise your right to view, update and/or correct information which
                you have submitted to Relic or a SEGA Group Company &nbsp;as part of the recruitment process, please contact: Data
                Protection Officer, &nbsp;Relic&nbsp; Entertainment Inc., 27 Great West Road, Brentford, Middlesex, TW8 9BW, United
                Kingdom or at&nbsp;
                <a rel="noopener" className={theme.BodyLink} target="_blank" href="mailto:DPO@SEGA.CO.UK">dpo@sega.co.uk</a>.</p>
              <p>We will try to comply with your request(s) as soon as reasonably practicable, consistent with applicable law. Note,
                in some cases and where permitted, we may charge a fee for data access requests.</p>
              <p>If you remain unhappy with a response you receive from us, you can also refer the matter to your data protection supervisory
                authority:&nbsp;
                <a rel="noopener" className={theme.BodyLink} target="_blank" href="https://www.priv.gc.ca/en/">https://www.priv.gc.ca/en/</a>
              </p>
            </div>
            <ul className={theme.Pagination}>
              <li className={theme.PaginationClose}>
                <NavLink
                  className={theme.CloseLink}
                  href={{
                    view: 'home',
                    params: { [HASH]: '#careers' },
                  }}
                  onClick={() => this.onClose()}>✕</NavLink>
              </li>
            </ul>
          </article>
        </div>
      </div>
    );
  }
}

themeable(CandidateNotice, {
  classes: [
    'Container',
    'BodyLink',
    'ArticleWrapper',
    'Article',
    'Pagination',
    'PaginationClose',
    'CloseLink',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/CandidateNotice.jsx